import { ApiError } from "./api";

export const KEY_TRANSFER_RETRY_DELAYS = [0, 250, 800, 2_000] as const;

export function keyRequestPollDelay(attempt: number): number {
  if (attempt <= 0) return 0;
  if (attempt <= 2) return 500;
  if (attempt <= 5) return 1_000;
  return 2_000;
}

export function isRetryableKeyTransferError(error: unknown): boolean {
  if (!(error instanceof ApiError)) return error instanceof TypeError;
  return error.status === 408 || error.status === 425 || error.status === 429 || error.status >= 500;
}

export function isCompletedKeyTransferRace(error: unknown): boolean {
  return error instanceof ApiError && (error.status === 404 || error.status === 409);
}

export async function retryKeyTransfer<T>(
  operation: () => Promise<T>,
  sleep: (milliseconds: number) => Promise<void> = (milliseconds) => new Promise((resolve) => window.setTimeout(resolve, milliseconds)),
): Promise<T> {
  let lastError: unknown;
  for (const delay of KEY_TRANSFER_RETRY_DELAYS) {
    if (delay > 0) await sleep(delay);
    try {
      return await operation();
    } catch (error) {
      lastError = error;
      if (!isRetryableKeyTransferError(error)) throw error;
    }
  }
  throw lastError;
}

